<template lang="pug">
  .footer-button
    el-button(
      :disabled="confirmButtonDisabled"
      v-if="!hidden"
      type="primary"
      :style="{ minWidth: buttonWidth }"
      @click="$emit('confirm')"
    ) {{ $t(confirmButton) }}
    el-button(
      v-if="!hidden && finishButton"
      style="margin: 0 40px"
      type="primary"
      :style="{ minWidth: buttonWidth }"
      @click="$emit('finish')"
    ) {{ $t(finishButton) }}
    el-button(
      :type="hidden ? 'primary' : ''"
      :style="{ width: buttonWidth }"
      @click="$emit('cancel')"
    ) {{ hidden ? $t('返回') : $t(cancelButton) }}
</template>

<script>
export default {
  props: {
    finishButton: {
      type: String,
      default: null
    },
    confirmButton: {
      type: String,
      default: '提交'
    },
    cancelButton: {
      type: String,
      default: '取消'
    },
    hidden: {
      type: Boolean,
      default: false
    },
    buttonWidth: {
      type: String,
      default: '65px'
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus">
.footer-button
  .el-button
    width 65px
    height 32px
</style>
